<template>
  <van-popup
    v-model="visibleInpopup"
    position="left"
    :style="{ height: 'calc(100%)', width: '77%' }"
    :overlay="true"
    :close-on-click-overlay="closeOnClickOverlay"
    @click-overlay="handleOverlayClick"
  >
    <div class="history-popup">
      <!-- 历史列表 -->
      <div class="history-list-wrapper">
        <div class="history-list">

          <van-pull-refresh
            v-model="refreshing"
            @refresh="$emit('refresh')"
          >
            <van-list
              :loading="loading"
              :immediate-check="true"
              :finished="finished"
              @load="$emit('load')"
              finished-text="没有更多了"
            >
              <van-cell
                :class="{
                  active: activeChat.chatId === historyItem.chatId,
                }"
                v-for="historyItem in historyList"
                :key="historyItem.chatId"
                :title="historyItem.title"
                @click="$emit('item-click', historyItem)"
              />
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
      <!-- 底部区域 -->
      <div class="bottom-area" @click="isAssociateCodeShow = true">
        <img :src="require('@/assets/jsyl/jsyl-associate.png')" />
        <span>联系客服</span>
      </div>
    </div>
    <van-popup
      get-container="#associate-popup-container"
      v-model="isAssociateCodeShow"
      @click="isAssociateCodeShow = false"
      :round="true"
      :overlay="true"
    >
      <div class="associate-popup">
        <div class="associate-title">联系客服</div>
        <div class="associate-desc">
          添加我们客服的联系方式为你提供定制化的专属服务套餐
        </div>
        <img
          class="associate-code"
          src="https://homepage-oss.oss-cn-beijing.aliyuncs.com/h5/kefu.jpg"
          alt=""
        />
        <div class="associate-action">扫一扫添加客服</div>
      </div>
    </van-popup>
  </van-popup>
</template>

<script>
import { Popup, List, PullRefresh, Cell } from "vant";

export default {
  name: "HistoryPopup",
  components: {
    [Popup.name]: Popup,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Cell.name]: Cell,
  },
  data() {
    return {
      visibleInpopup: false,
      loadingInPopup: false,
      isAssociateCodeShow: false,
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    refreshing: {
      type: Boolean,
      default: false,
    },
    finished: {
      type: Boolean,
      default: false,
    },
    immediateCheck: {
      type: Boolean,
      default: true,
    },
    // 控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    activeChat: {
      type: Object,
      default: () => {},
    },
    historyList: {
      type: Array,
      required: true,
      default: () => [],
    },
    // 点击遮罩是否关闭
    closeOnClickOverlay: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  mounted() {},
  watch: {
    visible(newVal, oldVal) {
      this.visibleInpopup = newVal
    },
    activeChat: {
      handler(newVal, oldVal) {
        console.log('activeChat', newVal.chatId);
      },
      deep: true,
    },
  },
  methods: {
    handleOverlayClick() {
      if (this.closeOnClickOverlay) {
        this.$emit("close");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.history-popup {
  height: 100%;
  overflow-y: hidden;
  .history-list-wrapper {
    height: calc(100% - 65px);
    overflow-y: scroll;
    .history-list {
      padding: 16px 8px 0;
      display: flex;
      flex-direction: column;
      .van-cell {
        padding: 12px;
        .van-cell__title {
          width: 100%;
          font-weight: 400;
          font-size: 16px;
          color: #000000;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        &::after {
          border-bottom: none;
        }
      }
      .van-cell.active {
        padding: 12px;
        border-radius: 20px;
        background-color: #e7e7e7;
      }
      .van-cell.inActive {
        padding: 12px;
      }
    }
  }
  .bottom-area {
    display: flex;
    width: 100%;
    position: fixed;
    gap: 9px;
    align-items: center;
    bottom: 0;
    padding: 20px;
    background-color: #fff;
    border-top: 1px solid #0000001a;
    > img {
      width: 24px;
      display: inline-block;
    }
  }
}
.associate-popup {
  width: 270px;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .associate-title {
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 17px;
    color: #1d2129;
  }
  .associate-desc {
    margin-bottom: 4px;
    font-weight: 400;
    font-size: 15px;
    color: #4e5969;
    text-align: center;
  }
  .associate-code {
    width: 157px;
  }
  .associate-action {
    width: 100%;
    padding: 8px;
    font-weight: 500;
    font-size: 16px;
    border-radius: 30px;
    color: #fff;
    text-align: center;
    background: #000000;
  }
}
</style>
